import { z } from 'zod';
import { Color } from 'libs/end-to-end/src/types/branding/color';
import { Icon } from 'libs/end-to-end/src/types/branding/icon';

export const LevelDefinition = z
  .object({
    columnValue: z.string(),
    displayName: z.string(),
    color: Color,
    icon: Icon,
    isPrivileged: z.boolean(),
  })
  .describe('LevelDefinition');

export type LevelDefinition = z.infer<typeof LevelDefinition>;
